import { module as modujs } from "modujs";
import Tempus from "@darkroom.engineering/tempus";

export default class extends modujs {
	constructor(m) {
		super(m);

		this.cursorSize = 128;
		this.fadeTime = 900;
		this.tweenPoints = 20;

		this.mouseX = -1000;
		this.mouseY = -1000;
		this.prevMouseX = -1000;
		this.prevMouseY = -1000;
		this.trailPositions = [];

		this.isMoving = false;
		this.lastMovementTime = 0;
	}

	init() {
		this.$canvas = this.$("canvas")[0];
		this.ctx = this.$canvas.getContext("2d");
		this.$container = this.el;

		this.resizeCanvas();

		window.addEventListener("resize", this.resizeCanvas.bind(this));
		this.$container.addEventListener("mousemove", this.handleMouseMove.bind(this));

		this.updater = Tempus.add((time) => {
			this.draw();
		});
	}

	resizeCanvas() {
		const rect = this.$container.getBoundingClientRect();
		this.$canvas.width = rect.width;
		this.$canvas.height = rect.height;
	}

	handleMouseMove(e) {
		const rect = this.$container.getBoundingClientRect();

		this.prevMouseX = this.mouseX;
		this.prevMouseY = this.mouseY;

		this.mouseX = e.clientX - rect.left;
		this.mouseY = e.clientY - rect.top;

		this.lastMovementTime = Date.now();

		if (this.prevMouseX !== -1000 && Math.abs(this.mouseX - this.prevMouseX) + Math.abs(this.mouseY - this.prevMouseY) > 1) {
			for (let i = 1; i <= this.tweenPoints; i++) {
				const ratio = i / this.tweenPoints;
				const tweenX = this.prevMouseX + (this.mouseX - this.prevMouseX) * ratio;
				const tweenY = this.prevMouseY + (this.mouseY - this.prevMouseY) * ratio;

				this.trailPositions.push({
					x: tweenX,
					y: tweenY,
					timestamp: Date.now() - (this.tweenPoints - i) * (16 / this.tweenPoints),
				});
			}
		}
	}

	draw() {
		this.ctx.clearRect(0, 0, this.$canvas.width, this.$canvas.height);

		const currentTime = Date.now();

		this.isMoving = currentTime - this.lastMovementTime < 16;

		this.trailPositions.forEach((position) => {
			const age = currentTime - position.timestamp;
			const opacity = 1 - age / this.fadeTime;

			if (opacity > 0) {
				this.ctx.beginPath();
				this.ctx.arc(position.x, position.y, this.cursorSize / 2, 0, Math.PI * 2);
				this.ctx.fillStyle = `rgba(255, 248, 230, 1)`;
				this.ctx.fill();
			}
		});

		if (this.isMoving) {
			this.ctx.beginPath();
			this.ctx.arc(this.mouseX, this.mouseY, this.cursorSize / 2, 0, Math.PI * 2);
			this.ctx.fillStyle = "rgba(255, 248, 230, 1)";
			this.ctx.fill();
		}

		this.trailPositions = this.trailPositions.filter((position) => {
			return currentTime - position.timestamp < this.fadeTime;
		});
	}

	destroy() {
		window.removeEventListener("resize", this.resizeCanvas.bind(this));
		this.$container.removeEventListener("mousemove", this.handleMouseMove.bind(this));
		this.updater();
	}
}
